import axios from 'axios';
import { Reservation } from '../types';

const API_BASE: string = import.meta.env.VITE_API_URL as string;

const apiClient = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const fetchIcalAvailability = async (): Promise<string> => {
    const response = await apiClient.get<string>('/calendar/ical', {
        responseType: 'text',
    });
    return response.data;
};

export const createReservation = async (reservation: Reservation): Promise<Reservation> => {
    const response = await apiClient.post<Reservation>('/Reservation', reservation);
    return response.data;
};

export const verifyReservation = async (reservationId: number, verificationCode: string): Promise<void> => {
    await apiClient.post('/Reservation/verify', {
        reservationId,
        verificationCode,
    });
};

export const updatePaymentMethod = async (reservationId: number, paymentMethod: 'transfer' | 'cash'): Promise<void> => {
    await apiClient.put(`/Reservation/${reservationId}/update-payment-method`, {
        paymentMethod,
    });
};

export default apiClient;
